import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Select, Input, Button, Pagination, Spin } from 'antd';
import Header from './header';
import Sidebar from './sidebar';
import { Link } from 'react-router-dom';
import '../style/TableStyle.css';

const { Option } = Select;

const FamilyList = () => {
  const [families, setFamilies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortBy, setSortBy] = useState('id');
  const [sortOrder, setSortOrder] = useState('asc');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [size, setSize] = useState(20);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchField, setSearchField] = useState('id');

  const API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/family/pagination';
  const SEARCH_API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/family/search';

  const getAllFamilies = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_URL, {
        params: {
          page: page - 1,
          size,
          sortBy,
          sortOrder,
          keyword: searchKeyword,
          searchField,
        },
      });
      setFamilies(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllFamilies();
  }, [page, size, sortBy, sortOrder]);

  const searchFamilies = async () => {
    try {
      const response = await axios.get(SEARCH_API_URL, {
        params: { keyword: searchKeyword, searchField },
      });
      setFamilies(response.data);
      setTotalPages(1);
    } catch (error) {
      setError(error);
    }
  };

  const columns = [
    {
      title: 'क्र.सं.',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'घर धनिको नाम',
      dataIndex: 'ownerNameNep',
      key: 'ownerNameNep',
    },
    {
      title: 'वडा नं',
      dataIndex: 'munWardName',
      key: 'munWardName',
    },
    {
      title: 'फोन',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: 'इमेल',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'कार्य',
      key: 'action',
      render: (text, record) => (
        <Link to={`/family/${record.id}/details`} className="text-blue-500">
          बिस्तृत विवरण
        </Link>
      ),
    },
  ];
  const rowClassName = (record, index) => {
    return index % 2 === 0
      ? 'even-row'
      : 'odd-row';
  };


  return (
    <div className="min-h-screen">
      <Header />
      <div className="flex pt-20">
        <Sidebar />
        <div className="flex-1 p-3 mt-15 lg:ml-64">
          <h1 className="text-2xl font-bold mb-6 pt-10">परिवारको सुची</h1>

          {/* Search and Sort Section */}
          <div className="flex flex-col md:flex-row justify-between items-center mb-6">
            <div className="flex items-center space-x-4 mb-4 md:mb-0">
              <Select
                value={searchField}
                onChange={(value) => setSearchField(value)}
                className="w-40"
              >
                <Option value="ownerNameEng">घरधनीको नाम</Option>
                <Option value="phone">फोन</Option>
                <Option value="email">इमेल</Option>
              </Select>
              <Input
                placeholder="खोज..."
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                className="w-52"
              />
              <Button onClick={searchFamilies} type="primary" className="bg-blue-500">
                खोज
              </Button>
            </div>

            {/* Sorting */}
            <div className="flex items-center space-x-4">
              <Select
                value={sortBy}
                onChange={(value) => setSortBy(value)}
                className="w-40"
              >
                <Option value="id">क्र.सं.</Option>
                <Option value="ownerNameEng">घरधनीको नाम</Option>
                <Option value="munWard">वडा नं</Option>
              </Select>
              <Select
                value={sortOrder}
                onChange={(value) => setSortOrder(value)}
                className="w-40"
              >
                <Option value="asc">माथिबाट</Option>
                <Option value="desc">तलबाट</Option>
              </Select>
            </div>
          </div>

          {/* Table Section */}
          {loading ? (
            <div className="flex justify-center items-center h-64">
              <Spin size="large" />
            </div>
          ) : (
            <div className="overflow-x-auto bg-white rounded-lg shadow">
              <Table

                dataSource={families}
                columns={columns}
                rowKey="id"
                pagination={false}
                rowClassName={rowClassName}
                bordered
                className="custom-table"
                loading={loading}
              />
            </div>
          )}

          {/* Pagination */}
          <div className="mt-4 flex justify-end">
            <Pagination
              current={page}
              pageSize={size}
              total={totalPages * size}
              onChange={(newPage, newPageSize) => {
                setPage(newPage);
                setSize(newPageSize);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyList;
